import { render, staticRenderFns } from "./MoshaverRating.vue?vue&type=template&id=da0d5138&scoped=true&"
import script from "./MoshaverRating.vue?vue&type=script&lang=js&"
export * from "./MoshaverRating.vue?vue&type=script&lang=js&"
import style0 from "./MoshaverRating.vue?vue&type=style&index=0&id=da0d5138&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0d5138",
  null
  
)

export default component.exports